import React from 'react';

export default class PrevArrow extends React.Component {
  render() {
    return (
      <svg width="22px" height="23px" viewBox="0 0 22 23" version="1.1">
          <g id="Symbols" stroke="none" strokeWidth="0" fill="none" fillRule="evenodd">
              <g id="Prev-Listing" className="nav-icon" transform="translate(-24.000000, -18.000000)" fill="#2AB7DF">
                  <g id="Back" transform="translate(24.000000, 18.000000)">
                      <polygon id="prev-arrow" points="5.22577098 9.68624973 12.9269072 1.93724995 11.0016231 0 0 11.0699997 11.0016231 22.1399994 12.9269072 20.2027494 5.22577098 12.4537497 22.0032462 12.4537497 22.0032462 9.68624973"></polygon>
                  </g>
              </g>
          </g>
      </svg>
    );
  }
}
